import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {formatarReal} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import moment from "moment/moment";

@inject("store")
@observer
export class DetalhamentoRecursoMOT extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {
        const dadosMot = this.controller.dadosMot;
        const solicitacao = this.controller.solicitacao;
        const admissao = this.controller.admissao ? moment(this.controller.admissao).format("DD/MM/YYYY") : "";
        const terminoContrato = this.controller.terminoContrato ? moment(this.controller.terminoContrato).format("DD/MM/YYYY") : "";
        const timesheet = this.controller.timesheet;
        return (
            <div>
                <h4>Recurso MOT</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>CPF </Label>
                            <NumberFormat className="form-control" format="###.###.###-##"
                                          value={dadosMot.cpf}
                                          readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Nome completo </Label>
                            <Input type="text" maxLength={128} value={dadosMot.nome} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Cargo</Label>
                            <Input type="text" value={_.get(solicitacao, "cargo.nome")} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Categoria</Label>
                            <Input type="text" value={_.get(solicitacao.cargo, "sindicato", "")} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Admissão</Label>
                            <Input className="form-control" type="text" value={admissao} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label for="dataFinal">Término contrato</Label>
                            <Input className="form-control" type="text" value={terminoContrato} readOnly/>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor salário base</Label>
                            <Input type="text"
                                   value={_.get(solicitacao, "salarioBase", null) ? formatarReal(_.get(timesheet, "salarioBase")) : ""}
                                   readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Jornada mensal (h)</Label>
                            <Input value={_.get(solicitacao, "jornadaMensal")} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}